<script>
import { computed, h } from "vue";
import "./ActionCol.scss";

export default {
  props: {
    dense: Boolean
  },
  setup(props, context) {
    const name = "sv-action-col";
    const classes = computed(() => {
      return {
        [name]: true,
        [`${name}--dense`]: props.dense
      };
    });

    return () => {
      if (typeof context.slots.default !== "function") return false;
      // Дописать дочерним элементам класс
      const children = context.slots.default().map(vnode => {
        if (!vnode?.data) return vnode;
        const staticClass = (vnode.data.staticClass || "") + ` ${name}__item`;
        vnode.data.staticClass = staticClass;
        return vnode;
      });

      return h(
        "div",
        {
          class: classes.value
        },
        [children]
      );
    };
  }
};
</script>
